export const ReliabilityExclusionPnHeader = [
  {
    header: "PN",
    key: "PN",
    width: 25,
  },
  {
    header: "EXCLUDE FAIL ON FIT",
    key: "EXCLUDE FAIL ON FIT",
  },
  {
    header: "EXCLUDE PREMATURE FAILURE",
    key: "EXCLUDE PREMATURE FAILURE",
  },
  {
    header: "EXCLUDE ROGUE UNIT",
    key: "EXCLUDE ROGUE UNIT",
  },
  {
    header: "CREATED BY",
    key: "CREATED BY",
  },
  {
    header: "CREATED DATE",
    key: "CREATED DATE",
  },
];

export const ReliabilityExclusionPnExcelName = "Exclusion PN List";
